export const ASSOCIATE_NOT_FOUND = 'Associate not found. Please contact Hera Support.'